import React from "react";

export default function ErrorPage() {
  return (
    <div style={{ marginTop: "6.25rem", textAlign: "center" }}>
      <h1>Ooops!</h1>
      <p>Something bad happened ...</p>
    </div>
  );
}
